import { makeStyles } from '@mui/styles';

export const useHubCardHeaderStyles = makeStyles(() => ({
  root: {
    padding: '0 24px 10px 24px',
    borderBottom: '1px solid lightgrey'
  },
  hubName: {
    fontSize: '17px',
    fontWeight: 600,
    marginBottom: '0.2rem'
  },
  lockerCount: {
    fontSize: '15px',
    marginBottom: '0.2rem'
  },
  utilisationCount: {
    height: '100%',
    paddingBottom: '8px',
    fontSize: '15px'
  },
  utilisationCountIconWrapper: {
    margin: '0 8px'
  },
  utilisationCountIcon: {
    width: '24px',
    color: '#6F6F6F'
  },
  controls: {
    height: '100%'
  },
  paddedControls: {
    padding: '8px'
  }
}));
